import { postInternalMessage } from '../initialize';
import { createAddCallableAssociationMessage } from 'calling-global-api/lib/internalEventMessageCreators';
import { triggerHostMessageAddCallableAssociation } from '../triggerHostMessage/triggerHostMessageAddCallableAssociation';
export default function addCallableAssociation(callableAssociation) {
  const message = createAddCallableAssociationMessage(callableAssociation);
  postInternalMessage(message);
  triggerHostMessageAddCallableAssociation(callableAssociation);
}